import { onBeforeUnmount, ref, watch } from 'vue'
import { ElNotification } from 'element-plus'
import { ContainersApi } from '~/services/apiClient'
import type {
  PortalName,
  ShippingLine,
  TerminalName,
} from '~/services/apiClient'

interface RefreshPayload {
  container_number: string
  terminal: TerminalName | undefined
  portal: PortalName
  shipping_line: ShippingLine | undefined
}

export function useRefreshStatus(
  getPayload: () => RefreshPayload,
  lastObserved: Ref<unknown>,
  entityName: string
) {
  const loading = ref(false)
  const loadTimeout = ref<NodeJS.Timeout | undefined>()

  function clearLoadTimeout() {
    if (loadTimeout.value) {
      clearTimeout(loadTimeout.value)
      loading.value = false
    }
  }

  watch(lastObserved, clearLoadTimeout)
  onBeforeUnmount(clearLoadTimeout)

  function refreshStatus() {
    const payload = getPayload()
    loading.value = true
    loadTimeout.value = setTimeout(() => {
      ElNotification.warning({
        title: `Failed to refresh ${entityName} for ${payload.container_number}`,
        message: `Refresh ${entityName} took too long. Try again in a few minutes.`,
      })
      loading.value = false
    }, 45000)

    const api = new ContainersApi()
    api.manualRefreshImportStatusesContainersImportStatusesRefreshPost([
      payload,
    ])
  }

  return {
    loading,
    refreshStatus,
  }
}
